'use client'

import { MessageType } from '@/shared/api'
import { useErrorDialogStore } from '@/shared/store'
import { AlertDialog, ConfirmDialog } from '@/shared/ui'

export const ErrorDialog = () => {
  const { type, actions, ...restProps } = useErrorDialogStore()

  return (
    <>
      {(() => {
        if (type === MessageType.ALERT) {
          return (
            <AlertDialog
              {...restProps}
              onOpenChange={actions.toggle}
              preventOutsideClick
            />
          )
        }

        return (
          <ConfirmDialog
            {...restProps}
            onOpenChange={actions.toggle}
            preventOutsideClick
          />
        )
      })()}
    </>
  )
}
